import { Component, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/shared/utils';
import { SearchService } from 'src/app/shared/services/search.service';


@Component({
  selector: 'app-antarcticbookingcenter',
  templateUrl: './antarcticbookingcenter.component.html',
  styleUrls: ['./antarcticbookingcenter.component.scss']
})
export class AntarcticbookingcenterComponent implements OnInit {

  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;

  constructor(
    public companyParamsService: CompanyParamsService,
    public router: Router,
    private searchService:SearchService
  ) { }
  showMenu: boolean = false;

  ngOnInit(): void {
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
    }, 300);
  }

  goHome() {
    this.searchService.setPage(1);
    let urlback: string = '';
    if (this.searchService.requestFindAvailability!.months ) {
      urlback =
        this.companyParamsService.getNameUrl() +
        '/search' +
        '/' + this.searchService.requestFindAvailability.adults +
        '/' + this.searchService.requestFindAvailability.children +
        '/' +
        (this.isNullOrUndefined(this.searchService.requestFindAvailability.dateFrom)?
        this.searchService.requestFindAvailability.months.join(",")+'/' +this.searchService.requestFindAvailability.year:
        this.searchService.requestFindAvailability.dateFrom+'/' +this.searchService.requestFindAvailability.dateTo)
        +
        '/' +  this.searchService.requestFindAvailability.priceFrom +
        '/' +  this.searchService.requestFindAvailability.priceTo +
        '/' +  this.searchService.requestFindAvailability.type +
        '/' +  this.searchService.requestFindAvailability.length +
        '/' +  this.searchService.requestFindAvailability.boat +
        '/' +  (this.searchService.requestFindAvailability.promotions.length === 0   ?  "0" : this.searchService.requestFindAvailability.promotions.join(",")) +
        '/' +  this.searchService.requestFindAvailability.order +
        '/' +  this.searchService.requestFindAvailability.categories +
        '/' +  (this.searchService.requestFindAvailability.charterOnly ? 'charter' : '0')+
        (this.isNullOrUndefined(this.searchService.requestFindAvailability.dateFrom)?'':'/calendar')
        ;
    } else {
      urlback =
        this.companyParamsService.getNameUrl() +
        '/search';
    }
    window.open(urlback, 'blank');
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

}
